import $ from 'jquery';

export const cookieBanner = () => {

    // Check if the "cookie_consent" cookie is set
    var cookieConsent = getCookie("cookie_consent");

    if (!cookieConsent && $('.cookie-banner').length ) {
        $(".cookie-banner").css("display", "flex").hide().fadeIn();
        // Detect scroll event and set cookie if scrolled past 200 pixels
        $(window).on('scroll', function() {
            if ($(window).scrollTop() > 200) {
                // setCookie("cookie_consent", "true", 365);
                $(".cookie-banner").attr('data-consent','true').fadeOut();
            }
        });
    }

    $(document).on( 'click', '#accept-cookie', function() {
        // Set the "cookie_consent" cookie with an expiration date of 1 year
        // setCookie("cookie_consent", "true", 365);
        $(".cookie-banner").fadeOut();
    });   

    // Function to get the value of a cookie
    function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length === 2) return parts.pop().split(";").shift();
    }

    // Function to set a cookie with a specific expiration date
    function setCookie(name, value, days) {
        var expires = new Date();
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = name + "=" + value + ";expires=" + expires.toUTCString() + ";path=/";
    }

}